import { AddInError, Container } from '@utils-global';
import { routes } from '../constants';
import { getGraphErrorContext, withGraphRetry } from './helpers';

export const deleteMail = async (
  mailId: string,
  userEmail: string,
  isSharedMailbox: boolean = false,
) => {
  try {
    return await withGraphRetry(
      () => Container.graphClient.delete(routes.office.deleteMail(mailId, userEmail)),
      { isSharedMailbox },
    );
  } catch (error) {
    throw new AddInError('Mail could not be deleted', getGraphErrorContext(error));
  }
};
